import { LoginService } from './../../../../../core/services/login.service';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Filter } from 'src/app/core/models/filter';
import { combineLatest } from 'rxjs';
import { pluck } from 'rxjs/operators';

const secondHandSuppliesSubscription = gql`subscription second_hand_supplies($andList: [second_hand_supplies_bool_exp!], $sortList:[second_hand_supplies_order_by!], $limit: Int, $offset: Int) {
  second_hand_supplies(where: {_and: $andList}, order_by: $sortList, limit: $limit, offset: $offset) {
    id
    created_at
    updated_at
    supply_category_id
    supply_category{
      id
      name
    }
    title
    description
    image
    more_images
    starting_price
    bid_ends_at
    is_featured
    type
    dental_supplier_id
    dental_supplier {
      id
      name
      business_name
    }
    dental_professional_id
    dental_professional{
      id
      name
    }
    dental_practice_id
    dental_practice{
      id
      name
    }
    status
    sold_out_at
    sold_out_message
    paused_at
    paused_message
    supply_sub_category_id
    supply_sub_category{
      id
      name
    }
    supply_brand_id
    supply_brand{
      id
      name
    }
    rejection_reason
    sku
    specifications
    seo_metadata
    video
    product_status
    buy_now_price
    color
    price_unit
    bid_starts_at
  }
}`;

const secondHandSuppliesAggregateSubscription = gql`subscription second_hand_supplies_aggregate($andList: [second_hand_supplies_bool_exp!]){
  second_hand_supplies_aggregate(where:{_and: $andList}) {
    aggregate {
      count
    }
  }
}`;


const draftStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  draft: second_hand_supplies_aggregate(where:{status:{_eq: "DRAFT"}}){
    aggregate{
      count
    }
  }
}`;


const approvalPendingStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  approval_pending: second_hand_supplies_aggregate(where:{status:{_eq: "PENDING_APPROVAL"}}){
    aggregate{
      count
    }
  }
}`;

const approvedStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  approved: second_hand_supplies_aggregate(where:{status:{_eq: "APPROVED"}}){
    aggregate{
      count
    }
  }
}`;

const rejectedStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  rejected: second_hand_supplies_aggregate(where:{status:{_eq: "REJECTED"}}){
    aggregate{
      count
    }
  }
}`;

const completedStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  completed: second_hand_supplies_aggregate(where:{status:{_eq: "COMPLETED"}}){
    aggregate{
      count
    }
  }
}`;

const stoppedStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  stopped: second_hand_supplies_aggregate(where:{status:{_eq: "STOPPED"}}){
    aggregate{
      count
    }
  }
}`;

const removedStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  removed: second_hand_supplies_aggregate(where:{status:{_eq: "REMOVED"}}){
    aggregate{
      count
    }
  }
}`;



const draftStatusCountUserSubscription = gql`subscription get_supply_aggregate_status_wise($user_id:uuid){
  draft: second_hand_supplies_aggregate(where:{
  status:{_eq: "DRAFT"},
  _or: [{
    dental_supplier_id: {_eq: $user_id }
  },{
    dental_practice_id: {_eq: $user_id }
  },{
    dental_professional_id: {_eq: $user_id }
  }]
}
  ){
    aggregate{
      count
    }
  }
}`;

const approvalPendingStatusCountUserSubscription = gql`subscription get_supply_aggregate_status_wise($user_id:uuid){
  approval_pending: second_hand_supplies_aggregate(where:{
  status:{_eq: "PENDING_APPROVAL"},
  _or: [{
    dental_supplier_id: {_eq: $user_id }
  },{
    dental_practice_id: {_eq: $user_id }
  },{
    dental_professional_id: {_eq: $user_id }
  }]
}){
    aggregate{
      count
    }
  }
}`;

const approvedStatusCountUserSubscription = gql`subscription get_supply_aggregate_status_wise($user_id:uuid){
  approved: second_hand_supplies_aggregate(where:{status:{_eq: "APPROVED"},
  _or: [{
    dental_supplier_id: {_eq: $user_id }
  },{
    dental_practice_id: {_eq: $user_id }
  },{
    dental_professional_id: {_eq: $user_id }
  }]

}){
    aggregate{
      count
    }
  }
}`;


const rejectedStatusCountUserSubscription = gql`subscription get_supply_aggregate_status_wise($user_id:uuid){
  rejected: second_hand_supplies_aggregate(where:{status:{_eq: "REJECTED"},
  _or: [{
    dental_supplier_id: {_eq: $user_id }
  },{
    dental_practice_id: {_eq: $user_id }
  },{
    dental_professional_id: {_eq: $user_id }
  }]

}){
    aggregate{
      count
    }
  }
}`;

const completedStatusCountUserSubscription = gql`subscription get_supply_aggregate_status_wise($user_id:uuid){
  completed: second_hand_supplies_aggregate(where:{status:{_eq: "COMPLETED"},
  _or: [{
    dental_supplier_id: {_eq: $user_id }
  },{
    dental_practice_id: {_eq: $user_id }
  },{
    dental_professional_id: {_eq: $user_id }
  }]

}){
    aggregate{
      count
    }
  }
}`;

const stoppedStatusCountUserSubscription = gql`subscription get_supply_aggregate_status_wise($user_id:uuid){
  stopped: second_hand_supplies_aggregate(where:{status:{_eq: "STOPPED"},
  _or: [{
    dental_supplier_id: {_eq: $user_id }
  },{
    dental_practice_id: {_eq: $user_id }
  },{
    dental_professional_id: {_eq: $user_id }
  }]

}){
    aggregate{
      count
    }
  }
}`;

const removedStatusCountUserSubscription = gql`subscription get_supply_aggregate_status_wise($user_id:uuid){
  removed: second_hand_supplies_aggregate(where:{status:{_eq: "REMOVED"},
  _or: [{
    dental_supplier_id: {_eq: $user_id }
  },{
    dental_practice_id: {_eq: $user_id }
  },{
    dental_professional_id: {_eq: $user_id }
  }]
}){
    aggregate{
      count
    }
  }
}`;


@Injectable({
  providedIn: 'root'
})
export class GetSecondHandSuppliesService {

  constructor(
    private apollo: Apollo,
    private loginService: LoginService) { }


  getSecondHandSupplies(filter: Filter){
    console.log(this.loginService.getLoginData());
    const andList: any =  [{
      status: {"_eq": filter.status}
     },{
      title: {"_ilike" : `%${filter.search}%`},
     }];
     const sortList:any = filter.sort;
     console.log(sortList);
     if(this.loginService.getLoginData().type === 'SUPPLIER'){
      andList.push({
        dental_supplier_id: {"_eq": this.loginService.getLoginData().id}
      });
     }
     if(this.loginService.getLoginData().type === 'PRACTICE'){
      andList.push({
        dental_practice_id: {"_eq": this.loginService.getLoginData().id}
      });
     }
     if(this.loginService.getLoginData().type === 'PROFESSIONAL'){
      andList.push({
        dental_professional_id: {"_eq": this.loginService.getLoginData().id}
      });
     }
     const filters: any = filter.filters.filter(single=>{
       return single.value && single.operator && single.value
     }).map(single=>{
      const columnParts = single.column.column.split(".");
      if(columnParts.length === 1){
        return {
          [single.column.column] :  {
           [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
         }
        }
      } else {
        return { [columnParts[0]] : {
          [columnParts[1]] :  {
           [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
         }
        }}
      }
     });
     const finalArray = andList.concat(filters);
     console.log(finalArray);
    return combineLatest([
      this.apollo.use('external').subscribe({
       query: secondHandSuppliesSubscription,
       fetchPolicy: "network-only",
       variables: {
         andList: finalArray,
         sortList,
         limit: filter.limit,
         offset: filter.offset
       }
      }).pipe(pluck('data', 'second_hand_supplies')),
      this.apollo.use('external').subscribe({
        query: secondHandSuppliesAggregateSubscription,
        fetchPolicy: "network-only",
        variables: {
          andList: finalArray
        }
      }).pipe(pluck('data', 'second_hand_supplies_aggregate', 'aggregate', 'count')),
      ['PRACTICE', 'SUPPLIER', 'PROFESSIONAL'].includes(this.loginService.getLoginData().type) ?
      combineLatest([
        this.apollo.use('external').subscribe({
          query: draftStatusCountUserSubscription,
          variables: {
            user_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "draft", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: approvalPendingStatusCountUserSubscription,
          variables: {
            user_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "approval_pending", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: approvedStatusCountUserSubscription,
          variables: {
            user_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "approved", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: rejectedStatusCountUserSubscription,
          variables: {
            user_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "rejected", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: completedStatusCountUserSubscription,
          variables: {
            user_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "completed", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: stoppedStatusCountUserSubscription,
          variables: {
            user_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "stopped", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: removedStatusCountUserSubscription,
          variables: {
            user_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "removed", 'aggregate', 'count'))
      ])
      :
      combineLatest([
        this.apollo.use('external').subscribe({
          query: draftStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "draft", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: approvalPendingStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "approval_pending", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: approvedStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "approved", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: rejectedStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "rejected", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: completedStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "completed", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: stoppedStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "stopped", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: removedStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "removed", 'aggregate', 'count'))
      ])
    ]);
  }
}
